// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"b4e9e57b","188":"72e5d7cf","374":"a8c8c3d8","518":"83939a9d","539":"dac28c8e","558":"76ec1e25","674":"04f163cb"}[chunkId] + ".chunk.js";
};